import axios from "axios";

const defaultState = {
  page: undefined,
};

export default {
  namespaced: true,

  state: {
    page: undefined,

    pageLoading: true,
  },

  mutations: {
    setPage(state, data) {
      state.page = data;
    },

    setPageLoading(state, data) {
      state.pageLoading = data;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    fetchPage({ commit, dispatch }, payload) {
      return axios.post(process.env.VUE_APP_API_URL + "pages/page-words", payload)
        .then(({ data }) => {
          commit("setPage", { ...data, keywords: payload.keywords });
        })
        .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    uploadScreenshot(_, payload) {
      return axios.post(process.env.VUE_APP_API_URL + "clips/screenshot",
        payload,
        { "Content-Type": "multipart/form-data" });
    },
  }
};